import store from "../../store";
import { setProductData } from "../../store/slices/product/productSlice";
import api from "../../utils/interface";

export const getProductListing = async () => {
  try {
    const response = await api.post(
      `/agsp/customer/getAllAccessibleProductsForCustomer`
    );
    if (response.status === 200) {
      store.dispatch(setProductData(response.data));
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching data", error);
  }
};
